import { render, staticRenderFns } from "./veJkyFundShen.vue?vue&type=template&id=3a3bce7d&scoped=true"
import script from "./veJkyFundShen.vue?vue&type=script&lang=js"
export * from "./veJkyFundShen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3bce7d",
  null
  
)

export default component.exports